import dynamic from 'next/dynamic'

export const DynamicMobileSearchModal = dynamic(
  () => import('.').then((mod) => mod.MobileSearchModal),
  { ssr: false },
)
